/**
 * M9 (CH-14b): recognising a disabled-hull Wire line by its headline. A leaf module (it reads only `wire-m9.json`), so
 * the main-thread Wire panel's *Disabled hulls* filter can use it without pulling the worker's Wire code in. The
 * line is a `notice` whose headline is one of `disabledHull.variants`, rendered; nothing is added to the saved item.
 * Pure.
 */
import wireM9Json from '../../data/strategic/wire-m9.json'

/** A headline pattern for template `t`: its fixed text with every `{slot}` as a wildcard (case-insensitive, anchored). */
function templatePattern(t: string): RegExp {
  const parts = t.split(/\{[a-z]+\}/).map((p) => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  return new RegExp(`^${parts.join('.+')}$`, 'i')
}

const DISABLED_HULL_PATTERNS: readonly RegExp[] = wireM9Json.disabledHull.variants.map(templatePattern)

/** True when `headline` is a disabled-hull line (one of wire-m9.json's variants, rendered). */
export function isDisabledHullHeadline(headline: string): boolean {
  return DISABLED_HULL_PATTERNS.some((p) => p.test(headline))
}
